export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/18a0c18db7b39714a58f61cec4296b4c.jpg"
        alt="Hero Background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-32">
        <div className="max-w-2xl">
          <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
            Secure Your Digital Life
          </h1>
          <p className="text-xl text-white/90 font-light mb-8 leading-relaxed">
            Experience ultimate privacy and security with POLONYI VPN. Protect your online identity with military-grade encryption and lightning-fast connections.
          </p>
          <button
            onClick={scrollToContact}
            className="px-8 py-3.5 bg-[#B8E986] text-gray-900 rounded-full text-base font-medium hover:bg-[#A5D675] transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started Now
          </button>
        </div>
      </div>
    </section>
  );
}
